import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import { Ui } from "../../services";
import {
  DownOutlined,
} from "../../../node_modules/@ant-design/icons";
import Api from "../../services/ServiceApi";

class MaxiOperationMaterial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      title: "Material Stock",
      active: 1.1,
    };
  }
  componentDidMount() {
    document.title = "Material Stock";
  }

  render() {
    const { loading, title, active } = this.state;
    return (
      <LayoutOperation active={5}>
        <div className="wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <img
              src={Api.absoluteUrl("/icon/material_stock_white.svg")}
              className="mr-3"
            />
            <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b fs-20">
              {title}
            </h2>
          </div>
        </div>
        <ul className="wrapper-tab">
          <li className={active % 1 != 0 ? "active" : ""}>
            <div className="dropdown ant-select-show-arrow">
              <button className="">
                Manage <DownOutlined />
                <i className="fa fa-caret-down"></i>
              </button>
              <div className="dropdown-content-mat">
                <div
                  style={{
                    backgroundColor: "#E0E0E0",
                    width: "90%",
                    margin: "auto",
                    height: 2,
                    padding: 0,
                  }}
                ></div>
                <div href="#" onClick={() => this.setState({ active: 1.6 })}>
                  Add New Materials
                </div>
                <div href="#" onClick={() => this.setState({ active: 1.1 })}>
                  Receive
                </div>
                <div href="#" onClick={() => this.setState({ active: 1.2 })}>
                  Reserve
                </div>
                <div href="#" onClick={() => this.setState({ active: 1.3 })}>
                  Return
                </div>
                <div href="#" onClick={() => this.setState({ active: 1.4 })}>
                  Transfer To Another Warehouse
                </div>
                <div href="#" onClick={() => this.setState({ active: 1.5 })}>
                  Adjust Material
                </div>
              </div>
            </div>
          </li>
          <li
            className={active === 2 ? "active" : ""}
            onClick={() => this.setState({ active: 2 })}
          >
            <button>Balance Stock</button>
          </li>
          <li
            className={active === 3 ? "active" : ""}
            onClick={() => this.setState({ active: 3 })}
          >
            <button>Ware House</button>
          </li>
          <li
            className={active === 4 ? "active" : ""}
            onClick={() => this.setState({ active: 4 })}
          >
            <button>Material List</button>
          </li>
          <li
            className={active === 5 ? "active" : ""}
            onClick={() => this.setState({ active: 5 })}
          >
            <button>Approve List</button>
          </li>
          <li
            className={active === 6 ? "active" : ""}
            onClick={() => this.setState({ active: 6 })}
          >
            <button>Report</button>
          </li>
        </ul>
        <div className="wrapper-body">
          {active < 2 && active > 1 ? <Ui.WareHouseForm type={active} /> : null}
          {active === 2 ? <Ui.BalanceStock /> : null}
          {active === 3 ? <Ui.WareHouse /> : null}
          {active === 4 ? <Ui.MaterialList /> : null}
          {active === 5 ? <Ui.ApproveList /> : null}
        </div>
      </LayoutOperation>
    );
  }
}

export default MaxiOperationMaterial;
